export default "__VITE_ASSET__BRlANyqc__"